import { useMutation } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const GetDuplicatePOExists = async (data) => {
  localStorage.removeItem('duplicatecheck');
  const newData = await axios.post(apiurl?.getDuplicatePO, data);
  await new Promise((resolve) => {
    localStorage.setItem('duplicatecheck', JSON.stringify(newData));
    resolve();
  });
  return newData;
};

const GetDuplicatePO = () => {
  return useMutation(GetDuplicatePOExists);
};

export default GetDuplicatePO;
